/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFramePeopleIcon16Solid = forwardRef('ScanFramePeopleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15 4a3 3 0 0 0-3-3h-1.5a1 1 0 0 0 0 2H12a1 1 0 0 1 1 1v1.5a1 1 0 1 0 2 0V4Z" }),
        React.createElement("path", { d: "M4 15a3 3 0 0 1-3-3v-1.5a1 1 0 0 1 2 0V12a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H4Z" }),
        React.createElement("path", { d: "M15 12a3 3 0 0 1-3 3h-1.5a1 1 0 1 1 0-2H12a1 1 0 0 0 1-1v-1.5a1 1 0 1 1 2 0V12Z" }),
        React.createElement("path", { d: "M4 1a3 3 0 0 0-3 3v1.5a1 1 0 0 0 2 0V4a1 1 0 0 1 1-1h1.5a1 1 0 0 0 0-2H4Z" }),
        React.createElement("path", { d: "M8 9c-1.06 0-3.083.142-3.533 2.13-.107.471.301.87.785.87h5.496c.484 0 .892-.399.785-.87C11.083 9.142 9.06 9 8 9Z" }),
        React.createElement("path", { d: "M8 7.999A2 2 0 1 0 8 4a2 2 0 0 0 0 3.999Z" })));
});
